import { InputAdornment, TextField } from "~/common/mui";
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import {
  MEDIA_QUERY_MIN_DESKTOP_M,
  MEDIA_QUERY_MIN_DESKTOP_S,
  MEDIA_QUERY_MIN_TABLET,
} from "~/common/utils/screenSizes";

interface AccountSelectionSearchProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const AccountSelectionSearch = ({ value, onChange }: AccountSelectionSearchProps) => {
  const { t } = useTranslation();
  return (
    <TextField
      sx={{
        minWidth: "auto",
        width: "100%",

        [`@media ${MEDIA_QUERY_MIN_TABLET}`]: {
          width: "60%",
        },
        [`@media ${MEDIA_QUERY_MIN_DESKTOP_S}`]: {
          width: "40%",
        },
        [`@media ${MEDIA_QUERY_MIN_DESKTOP_M}`]: {
          width: "25%",
        },
      }}
      className="mb-3"
      variant="outlined"
      label={t("accountSelection.search.label")}
      value={value}
      onChange={onChange}
      placeholder={t("accountSelection.search.helperText")}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Icon sx={{ marginRight: "8px" }} type={IconType.Search} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default AccountSelectionSearch;
